export const getConfig = () => ({
    apiUrl: window.REACT_APP_API_URL ?? process.env.REACT_APP_START_SERVICE_SUBMIT_API,
    identityPoolId: window.IDENTITY_POOL_ID ?? process.env.REACT_APP_IDENTITY_POOL_ID,
    placeIndexName: window.PLACE_INDEX_NAME ?? process.env.REACT_APP_PLACE_INDEX_NAME,
    region: window.REGION ?? process.env.REACT_APP_REGION,
    version: window.REACT_APP_VERSION
  });